import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = sp.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { await refresh(); setStatus("paid"); return; }
        if (data.status === "expired" || tries > 10) { setStatus("error"); return; }
      } catch { if (tries > 10) { setStatus("error"); return; } }
      tries++; setTimeout(poll, 1800);
    };
    poll();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#030303] flex items-center justify-center p-5 starfield">
      <div className="glass rounded-2xl p-10 text-center max-w-md relative">
        {status === "checking" && <><Loader2 className="w-12 h-12 animate-spin text-eblue mx-auto mb-4" /><div className="font-display font-bold text-xl">Confirming your payment…</div></>}
        {status === "paid" && <><CheckCircle2 className="w-14 h-14 text-gold mx-auto mb-4" /><div className="font-display font-bold text-2xl text-gold-grad">Welcome to VirtuStars+</div><p className="text-sm text-muted-foreground mt-2">Your premium creator tools are unlocked.</p><Button onClick={() => nav("/studio")} className="btn-gold rounded-xl mt-6">Open Creator Studio</Button></>}
        {status === "error" && <><XCircle className="w-14 h-14 text-rose-400 mx-auto mb-4" /><div className="font-display font-bold text-xl">Payment not confirmed</div><p className="text-sm text-muted-foreground mt-2">If you completed checkout, it may take a moment. Otherwise try again.</p><Link to="/plus"><Button className="btn-blue rounded-xl mt-6">Back to Upgrade</Button></Link></>}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#030303] flex items-center justify-center p-5">
      <div className="glass rounded-2xl p-10 text-center max-w-md">
        <XCircle className="w-14 h-14 text-muted-foreground mx-auto mb-4" />
        <div className="font-display font-bold text-xl">Checkout cancelled</div>
        <p className="text-sm text-muted-foreground mt-2">No charge was made.</p>
        <Button onClick={() => nav("/plus")} className="btn-blue rounded-xl mt-6">Back to Upgrade</Button>
      </div>
    </div>
  );
}
